export const cleStockageJeton = "alpha-design-studio.alphaToolsBearer";

export function lireJetonStudio(): string | null {
  return sessionStorage.getItem(cleStockageJeton);
}

export function enregistrerJetonStudio(jeton: string): void {
  sessionStorage.setItem(cleStockageJeton, jeton);
}

export function supprimerJetonStudio(): void {
  sessionStorage.removeItem(cleStockageJeton);
}

export interface SessionStudio {
  utilisateur: {
    idUtilisateur: string;
    nomConnexion: string;
    nomAffiche: string;
    email: string;
    niveauAdmin: string;
  };
  organisations: Array<{
    idOrganisation: string;
    codeOrganisation: string;
    nomOrganisation: string;
  }>;
  codesApplication: string[];
  modeAcces: "admin_suite" | "application";
}

export interface ReponseConnexion {
  jetonAcces?: string;
  statut?: string;
  message?: string;
  mfaTicket?: string;
  session?: SessionStudio;
}

export interface EditeurToken {
  chemin: string;
  categorie: string;
  nom: string;
  valeur: string | Record<string, string>;
  surchargeApplicative: boolean;
}

export interface ReponseTokens {
  meta: Record<string, unknown>;
  tokens: Record<string, Record<string, unknown>>;
  surchargesAutorisees?: string[];
  editeurs: EditeurToken[];
}

export interface SurchargeToken {
  chemin: string;
  theme?: string;
  valeur: string;
}

export interface RapportSurcharge {
  erreurs: string[];
  avertissements: string[];
  tokens: ReponseTokens;
}

export interface ComposantCatalogue {
  nom: string;
  package: string;
  import: string;
  description: string;
  motsCles?: string[];
  reglagesVisuels?: ReglagesVisuelsComposantCatalogue;
}

export interface ReglagesVisuelsComposantCatalogue {
  alignement?: "gauche" | "centre" | "droite";
  apparenceMenu?: ReglagesVisuelsMenuCatalogue;
  arrondi?: number;
  couleurAccent?: string;
  couleurFond?: string;
  couleurTexte?: string;
  espace?: number;
  largeur?: "compacte" | "standard" | "large";
  tailleControle?: "compacte" | "standard" | "large";
  tailleTexte?: number;
}

export interface ReglagesVisuelsMenuCatalogue {
  fond?: string;
  texte?: string;
  police?: string;
  rayon?: number;
  entreeFond?: string;
  entreeTexte?: string;
  entreeSurvolFond?: string;
  entreeSurvolTexte?: string;
  entreeActiveFond?: string;
  entreeActiveTexte?: string;
  entreeRayon?: number;
  entreeTailleTexte?: number;
  iconeCouleur?: string;
  iconeActiveCouleur?: string;
  iconeTaille?: number;
  iconesVisibles?: boolean;
  sousMenuFond?: string;
  sousMenuTexte?: string;
  sousMenuSurvolFond?: string;
  sousMenuSurvolTexte?: string;
  sousMenuActiveFond?: string;
  sousMenuActiveTexte?: string;
  sousMenuRayon?: number;
  sousMenuTailleTexte?: number;
  sousMenuRetrait?: number;
}

export interface BrouillonStudio {
  id: string;
  nom: string;
  type: string;
  source: string;
  contenu: string;
  modifieLe: string;
}

export interface PromotionBrouillon {
  nom: string;
  package: "@alpha/ui";
  chemin: string;
  import: string;
  generationCatalogue: {
    commande: string;
    code: number;
    sortie: string;
    erreur: string;
  };
}

export interface SuppressionComposantStudio {
  nom: string;
  package: "@alpha/ui";
  chemin: string;
  generationCatalogue: {
    commande: string;
    code: number;
    sortie: string;
    erreur: string;
  };
}

export interface ProfilApparence {
  id: string;
  nom: string;
  description: string;
  famillePolice: string;
  tailleBase: number;
  tailleTitre: number;
  graisseTitre: number;
  styleCarte: "dense" | "equilibre" | "editorial";
  couleurPrincipale: string;
  couleurSurface: string;
  couleurTexte: string;
  couleurAccent: string;
  gradientDepart: string;
  gradientArrivee: string;
  angleDegres: number;
  imageUrl: string;
  arrondi: number;
  intensiteOmbre: number;
  modifieLe: string;
}

export interface ReponsePreproductionDesignSystem {
  statut: "pret" | "avertissement" | "bloque";
  titre: string;
  message: string;
  emplacement: {
    dossier: string;
    paquet: string;
    rapport: string;
    rapportValidation: string | null;
  };
  comparaison: {
    message: string;
    changements: number;
  };
  validation: {
    disponible: boolean;
    commande: string;
    code: number | null;
    sortie: string;
    erreur: string;
  };
  avertissements: string[];
  erreurs: string[];
}

export interface ReponseApplicationOfficielleDesignSystem {
  statut: "pret" | "avertissement" | "bloque";
  titre: string;
  message: string;
  cible: {
    branche: string;
    commit: string;
    propreAvant: boolean;
    statutApres: string;
  };
  emplacement: {
    dossier: string;
    copieIsolee: string;
    paquet: string;
    rapport: string;
    rapportValidation: string | null;
  };
  comparaison: {
    message: string;
    changements: number;
  };
  application: {
    fichiersModifies: string[];
    fichiersCrees: string[];
    fichiersSupprimes: string[];
    changementsInattendus: string[];
  };
  validations: Array<{
    nom: string;
    commande: string;
    code: number;
    sortie: string;
    erreur: string;
  }>;
  avertissements: string[];
  erreurs: string[];
}

export type StatutApplicationAlpha =
  | "non_verifiee"
  | "a_jour"
  | "accessible"
  | "ecart"
  | "indisponible";

export interface VerificationApplicationAlpha {
  statut: StatutApplicationAlpha;
  titre: string;
  message: string;
  verifieLe: string;
  dureeMs: number;
  disponibilite: {
    codeHttp: number | null;
    disponible: boolean;
  };
  charte: {
    verifiee: boolean;
    correspond: boolean | null;
    variablesAttendues: number;
    variablesCorrespondantes: number;
    variablesManquantes: string[];
    empreinteAttendue: string | null;
    empreinteDetectee: string | null;
  };
}

export interface SaisieApplicationAlpha {
  nom: string;
  environnement: string;
  url: string;
  cheminSante: string;
  active: boolean;
  pilote: boolean;
  verifierCharte: boolean;
  profilDeploiement: string | null;
}

export interface ApplicationAlpha extends SaisieApplicationAlpha {
  id: string;
  creeLe: string;
  modifieLe: string;
  derniereVerification: VerificationApplicationAlpha | null;
}

export interface EvenementPublicationAlpha {
  id: string;
  type:
    | "configuration"
    | "preproduction"
    | "bibliotheque"
    | "verification_application"
    | "deploiement_application";
  statut: "reussi" | "attention" | "echec" | "information";
  titre: string;
  message: string;
  creeLe: string;
  acteur: { id: string; nom: string };
  applicationId: string | null;
  nomCharte: string | null;
  empreinteCharte: string | null;
}

export interface ProfilDeploiementAlpha {
  id: string;
  nom: string;
  description: string;
  environnement: string;
  applicationUrl: string;
}

export interface EtapeDeploiementAlpha {
  id: string;
  libelle: string;
  statut: "a_venir" | "en_cours" | "reussie" | "echec";
  commenceLe: string | null;
  termineeLe: string | null;
  message: string;
  journal: string;
}

export interface DeploiementApplicationAlpha {
  version: 1;
  id: string;
  applicationId: string;
  applicationNom: string;
  environnement: string;
  profilId: string;
  profilNom: string;
  statut: "en_attente" | "en_cours" | "reussi" | "echec";
  titre: string;
  message: string;
  creeLe: string;
  commenceLe: string | null;
  termineLe: string | null;
  acteur: { id: string; nom: string };
  empreinteCharte: string;
  typeOperation: "mise_a_jour" | "restauration";
  restaurationDisponible: boolean;
  etapes: EtapeDeploiementAlpha[];
}

export interface ReponsePublicationApplications {
  applications: ApplicationAlpha[];
  historique: EvenementPublicationAlpha[];
  charteActuelle: {
    empreinte: string | null;
    variables: number;
  };
  profilsDeploiement: ProfilDeploiementAlpha[];
  deploiements: DeploiementApplicationAlpha[];
}

export class ErreurApi extends Error {
  constructor(
    public readonly statut: number,
    public readonly code: string,
    message: string
  ) {
    super(message);
  }
}

export async function requeteApi<Reponse>(
  chemin: string,
  options: RequestInit = {}
): Promise<Reponse> {
  const jeton = lireJetonStudio();
  const entetes = new Headers(options.headers);
  entetes.set("content-type", "application/json");
  if (jeton) entetes.set("Authorization", `Bearer ${jeton}`);

  const reponse = await fetch(chemin, { ...options, headers: entetes });
  const texte = await reponse.text();
  const payload = texte ? (JSON.parse(texte) as unknown) : {};

  if (!reponse.ok) {
    const objet = lireObjet(payload);
    throw new ErreurApi(
      reponse.status,
      lireTexte(objet, "code") || "erreur_api",
      lireTexte(objet, "message") || "Erreur API."
    );
  }

  return payload as Reponse;
}

export async function envoyerChartePreproductionDesignSystem(
  paquet: unknown
): Promise<ReponsePreproductionDesignSystem> {
  return requeteApi<ReponsePreproductionDesignSystem>("/api/design-system/preproduction", {
    method: "POST",
    body: JSON.stringify({ paquet })
  });
}

export async function appliquerCharteDesignSystemOfficiel(
  paquet: unknown
): Promise<ReponseApplicationOfficielleDesignSystem> {
  return requeteApi<ReponseApplicationOfficielleDesignSystem>(
    "/api/design-system/application-officielle",
    {
      method: "POST",
      body: JSON.stringify({ paquet })
    }
  );
}

export async function chargerPublicationApplications(): Promise<ReponsePublicationApplications> {
  return requeteApi<ReponsePublicationApplications>("/api/publication/applications");
}

export async function enregistrerApplicationAlpha(
  saisie: SaisieApplicationAlpha,
  id?: string
): Promise<ApplicationAlpha> {
  const reponse = await requeteApi<{ application: ApplicationAlpha }>(
    id
      ? `/api/publication/applications/${encodeURIComponent(id)}`
      : "/api/publication/applications",
    {
      method: id ? "PUT" : "POST",
      body: JSON.stringify(saisie)
    }
  );
  return reponse.application;
}

export async function supprimerApplicationAlpha(id: string): Promise<void> {
  await requeteApi(`/api/publication/applications/${encodeURIComponent(id)}`, {
    method: "DELETE"
  });
}

export async function verifierApplicationAlpha(
  id: string
): Promise<VerificationApplicationAlpha> {
  const reponse = await requeteApi<{ verification: VerificationApplicationAlpha }>(
    `/api/publication/applications/${encodeURIComponent(id)}/verifier`,
    { method: "POST" }
  );
  return reponse.verification;
}

export async function deployerApplicationAlpha(
  id: string
): Promise<DeploiementApplicationAlpha> {
  const reponse = await requeteApi<{ deploiement: DeploiementApplicationAlpha }>(
    `/api/publication/applications/${encodeURIComponent(id)}/deployer`,
    { method: "POST" }
  );
  return reponse.deploiement;
}

export async function restaurerApplicationAlpha(
  id: string
): Promise<DeploiementApplicationAlpha> {
  const reponse = await requeteApi<{ deploiement: DeploiementApplicationAlpha }>(
    `/api/publication/applications/${encodeURIComponent(id)}/restaurer`,
    { method: "POST" }
  );
  return reponse.deploiement;
}

function lireObjet(valeur: unknown): Record<string, unknown> {
  return typeof valeur === "object" && valeur !== null && !Array.isArray(valeur)
    ? (valeur as Record<string, unknown>)
    : {};
}

function lireTexte(valeur: Record<string, unknown>, cle: string): string {
  const entree = valeur[cle];
  return typeof entree === "string" ? entree : "";
}
